var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommittedSmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z",
    fill: "#F4EFFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.5C5.933 7.5 7.5 5.933 7.5 4C7.5 2.067 5.933 0.5 4 0.5C2.067 0.5 0.5 2.067 0.5 4C0.5 5.933 2.067 7.5 4 7.5Z",
    fill: "#706F81",
    stroke: "#5D21D2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7842 0L2.52103 11",
    stroke: "#5D21D2",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7002 -2L-6.2998 11",
    stroke: "#5D21D2",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36328 0L-1.89988 11",
    stroke: "#5D21D2",
    strokeWidth: 1.6
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommittedSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/committedSmall.7caab77a1cc152f1e9bb087e1955f84d.svg";